import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import closeButton from 'assets/close.svg';

import { setLargeChatSize as setLargeChatSizeAction } from '../../../../store/actions';
import { behavior as behaviorSelectors } from '../../../../store/selectors';
import Header from './components/Header';
import Messages from './components/Messages';
import Sender from './components/Sender';
import ConsentOverlay from '../ConsentOverlay';
import ThemeContext from '../../ThemeContext';
import './style.scss';

const _Conversation = (props) => {
    const { largeChatSize, setLargeChatSize } = props;
    const { t } = useTranslation();

    const {
        conversationWindowHeight,
        conversationWindowWidth,
        conversationWindowHeightLarge,
        conversationWindowWidthLarge,
        consent,
        disclaimer,
    } = React.useContext(ThemeContext);

    const toggleChatsize = React.useCallback(() => {
        setLargeChatSize(!largeChatSize);
    }, [largeChatSize, setLargeChatSize]);

    const [height, setHeight] = React.useState(conversationWindowHeight);
    const [width, setWidth] = React.useState(conversationWindowWidth);
    React.useEffect(() => {
        setHeight(
            largeChatSize && conversationWindowHeightLarge
                ? conversationWindowHeightLarge
                : conversationWindowHeight
        );
    }, [largeChatSize, conversationWindowHeight, conversationWindowHeightLarge, setHeight]);
    React.useEffect(() => {
        setWidth(
            largeChatSize && conversationWindowWidthLarge
                ? conversationWindowWidthLarge
                : conversationWindowWidth
        );
    }, [largeChatSize, conversationWindowWidth, conversationWindowWidthLarge, setWidth]);

    return (
        <div
            id="rw-conversation-container"
            className="rw-conversation-container"
            style={{
                '--widget-conversation-window-height': height,
                '--widget-conversation-window-width': width,
            }}
        >
            {props.showTitleBar !== false && (
                <Header
                    title={props.title}
                    subtitle={props.subtitle}
                    toggleChat={props.toggleChat}
                    toggleChatsize={
                        conversationWindowHeightLarge || conversationWindowWidthLarge
                            ? toggleChatsize
                            : undefined
                    }
                    largeChatsizeEnabled={largeChatSize}
                    toggleFullScreen={props.toggleFullScreen}
                    fullScreenMode={props.fullScreenMode}
                    showCloseButton={props.showCloseButton}
                    showFullScreenButton={props.showFullScreenButton}
                    connected={props.connected}
                    connectingText={props.connectingText}
                    closeImage={props.closeImage}
                />
            )}
            {props.showTitleBar === false && props.compactCloseBar && (
                <div className="rw-takeover-bar">
                    <button
                        type="button"
                        className="rw-takeover-exit rw-takeover-close"
                        onClick={props.toggleChat}
                        aria-label={t('takeover.closeLabel')}
                    >
                        <img src={closeButton} alt="" />
                    </button>
                </div>
            )}
            <Messages
                params={props.params}
                customComponent={props.customComponent}
                showMessageDate={props.showMessageDate}
            />
            <Sender
                sendMessage={props.sendMessage}
                disabledInput={props.disabledInput}
                inputTextFieldHint={props.inputTextFieldHint}
                embedded={props.embedded}
                mobileFullScreenOnFocus={props.mobileFullScreenOnFocus}
            />
            {disclaimer?.enabled && disclaimer?.text && (
                <div className="rw-disclaimer">{disclaimer.text}</div>
            )}
            {consent?.enabled && (
                <ConsentOverlay
                    buttonText={consent.buttonText}
                    buttonColor={consent.buttonColor}
                    privacyLinkUrl={consent.privacyLinkUrl}
                    privacyLinkText={consent.privacyLinkText}
                    storageKey={consent.storageKey}
                    text={consent.text}
                />
            )}
        </div>
    );
};

_Conversation.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    sendMessage: PropTypes.func,
    toggleFullScreen: PropTypes.func,
    fullScreenMode: PropTypes.bool,
    toggleChat: PropTypes.func,
    showCloseButton: PropTypes.bool,
    showFullScreenButton: PropTypes.bool,
    disabledInput: PropTypes.bool,
    inputTextFieldHint: PropTypes.string,
    embedded: PropTypes.bool,
    mobileFullScreenOnFocus: PropTypes.bool,
    params: PropTypes.object,
    connected: PropTypes.bool,
    connectingText: PropTypes.string,
    closeImage: PropTypes.string,
    customComponent: PropTypes.func,
    showMessageDate: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    showTitleBar: PropTypes.bool,
    compactCloseBar: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
    return {
        largeChatSize: behaviorSelectors.largeChatSize(state.behavior),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setLargeChatSize: (enabled) => dispatch(setLargeChatSizeAction(enabled)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(_Conversation);
